module.exports = __webpack_public_path__ + "img/login.2ec6d67.png";